module.exports = __webpack_public_path__ + "img/no label.6d727251.png";